import { API_BASE_URL } from "../config";
import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${API_BASE_URL}/api/auth/login`, {
        email,
        password,
      });

      login(res.data.token, res.data.user);
      navigate("/");
    } catch (err) {
      if (!err.response) {
        setError("Connecting to backend database server... Please wait a few seconds and try again.");
      } else {
        setError(err.response.data?.message || "Login failed. Please check credentials.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h2 style={styles.title}>Client Login</h2>
          <p style={styles.subtitle}>OpenBull Demo Paper Trading Platform</p>
        </div>

        {error && <div style={styles.errorAlert}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="e.g. client1@demo.com"
              required
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={styles.input}
            />
          </div>

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? "Logging in..." : "Login to Trading Dashboard"}
          </button>
        </form>

        <div style={styles.demoBox}>
          <strong>Demo Client Login:</strong>
          <div>Email: <code>client1@demo.com</code> | Password: <code>client123</code></div>
        </div>

        <div style={styles.footer}>
          Don't have an account? <Link to="/signup" style={styles.link}>Sign Up</Link>
          <br />
          <Link to="/admin/login" style={{ ...styles.link, color: "#666", marginTop: "8px", display: "inline-block" }}>
            🔐 Switch to Admin Login
          </Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f7fa",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  card: {
    width: "100%",
    maxWidth: "420px",
    padding: "36px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
  },
  header: {
    textAlign: "center",
    marginBottom: "24px",
  },
  title: {
    margin: 0,
    color: "#387ed1",
    fontSize: "24px",
    fontWeight: 600,
  },
  subtitle: {
    margin: "6px 0 0",
    color: "#666",
    fontSize: "14px",
  },
  errorAlert: {
    backgroundColor: "#ffebee",
    color: "#c62828",
    padding: "10px 14px",
    borderRadius: "6px",
    fontSize: "14px",
    marginBottom: "16px",
    borderLeft: "4px solid #ef5350",
  },
  formGroup: {
    marginBottom: "18px",
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontSize: "13px",
    fontWeight: 500,
    color: "#444",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  button: {
    width: "100%",
    padding: "12px",
    backgroundColor: "#387ed1",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    marginTop: "8px",
  },
  demoBox: {
    marginTop: "20px",
    padding: "10px 12px",
    backgroundColor: "#eef6ff",
    borderRadius: "6px",
    fontSize: "12px",
    color: "#2b568f",
  },
  footer: {
    marginTop: "20px",
    textAlign: "center",
    fontSize: "13px",
    color: "#666",
  },
  link: {
    color: "#387ed1",
    textDecoration: "none",
    fontWeight: 500,
  },
};

export default Login;
